<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<div class="box-main">
				<div class="box-main-top">Urgent dispatches reason</div>
				<div class="box-main-bottom">{{ accidentReason }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'report',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			accidentReason: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.accidentReason = this.$route.query.accidentReason;
			this.height = window.innerHeight;
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		padding-top: 64px;
		box-sizing: border-box;
		.box-main {
			width: 100%;
			height: 631px;
			border-radius: 38px;
			background-image: url(../../assets/cancel.png);
			background-size: 100% 100%;
			padding: 35px 0 15px 21px;
			box-sizing: border-box;
			.box-main-top {
				width: 277px;
				height: 49px;
				font-size: 20px;
				color: #2efeff;
				line-height: 49px;
				text-align: center;
				background-image: url(../../assets/title.png);
				background-size: 100% 100%;
				padding-left: 30px;
				box-sizing: border-box;
			}
			.box-main-bottom {
				padding: 56px 90px 0 75px;
				box-sizing: border-box;
				font-size: 24px;
				color: #00fff0;
				line-height: 48px;
			}
		}
	}
}
</style>
